<template>
    <v-container fluid>
        <v-tabs
            v-model="tab"
            fixed-tabs
        >
            <v-tab key="1" @click="getOrders">
                Orders
            </v-tab>
            <v-tab key="2" @click="getQuickBooksPurchaseOrders">
                Quick Books - PO
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            
            <!-- ORDERS -->
            <v-tab-item key="1">
                <br />
                <v-row>
                    <v-col cols="12">
                        <v-form @submit.prevent="getOrders">
                            <v-text-field
                                v-model="filter.fastSearch"
                                label="Quick Search"
                                prepend-inner-icon="mdi mdi-magnify"
                                single-line
                                outlined
                                @click:prepend-inner="getOrders"
                                dense
                            ></v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                    >
                        <label>Customer</label>
                        <v-combobox
                            v-model="filter.customerSelected"
                            :items="listCustomer"
                            item-text="fullName"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="3"
                        md="6"
                        sm="12"
                    >
                        <label>Product</label>
                        <v-combobox
                            v-model="filter.productSelected"
                            :items="listProduct"
                            item-text="description"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="2"
                        md="4"
                        sm="12"
                    >
                        <label>Status</label>
                        <v-combobox
                            v-model="filter.statusSelected"
                            :items="listStatus" 
                            item-text="statusDescription"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="2"
                        md="4"
                        sm="12"
                    >
                        <label>Phase</label>
                        <v-combobox
                            v-model="filter.phaseSelected"
                            :items="listProjectPhases" 
                            item-text="statusDescription"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="1"
                        md="4"
                        sm="12"
                    >
                        <label>Only Special Orders</label>
                        <v-switch
                            v-model="filter.onlySpecialOrder"
                            inset
                            dense
                            @change="filterRegisters(); getOrders()"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        cols="6"
                        lg="2"
                        md="4"
                        sm="6"
                    >
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    :disabled="disabledCreate"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="confirmSendToApproveQBOrder()"
                                >
                                    Create
                                </v-btn>
                            </template>
                            <span>Create a new quick book order</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12">
                        <v-data-table
                            v-model="ordersSelected"
                            :headers="headers"
                            :items="filteredSearch"
                            :options.sync="options"
                            :loading="loading"
                            :items-per-page="10"
                            show-select
                            no-data-text="No Record Found"
                        >
                            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                <v-simple-checkbox
                                    v-if="item.status == 1" 
                                    :value="isSelected"
                                    @input="select($event)"
                                ></v-simple-checkbox>
                            </template>
                            
                            <template v-slot:item.statusDescription="{ item }">
                                <v-chip
                                    :color="getStatusColor(item.status)"
                                    outlined
                                    dark
                                >
                                    {{ item.statusDescription }}
                                </v-chip>
                            </template>

                            <template v-slot:item.action="{item}">
                                <ActionList 
                                    :id="item.id" 
                                    :showButtons="{
                                        view: true,
                                        cancel2: item.status === 1 ? true : false,
                                        active: item.status === 99 ? true : false,
                                        approve: item.status == 2 && canApproveRequestWareHouse ? true : false,
                                    }"
                                    @confirmCancel2="confirmCancel"
                                    @confirmActive="confirmActive"
                                    @confirmView="showHistory"
                                    @confirmApprove="showQBOptions = true;"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                    
            </v-tab-item>

            <!-- QUICK BOOKS -->
            <v-tab-item key="2">
                <br />
                <v-row>
                    <v-col cols="12">
                        <v-form @submit.prevent="getQuickBooksPurchaseOrders">
                            <v-text-field
                                v-model="filter.fastSearch"
                                label="Quick Search"
                                prepend-inner-icon="mdi mdi-magnify"
                                single-line
                                outlined
                                @click:prepend-inner="getQuickBooksPurchaseOrders"
                                dense
                            ></v-text-field>
                        </v-form>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col 
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                    >
                        <label>Status</label>
                        <v-combobox
                            v-model="filter.statusSelected"
                            :items="listStatus" 
                            item-text="statusDescription"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                    <v-col 
                        cols="12"
                        lg="6"
                        md="6"
                        sm="12"
                    >
                        <label>Vendor</label>
                        <v-combobox
                            v-model="filter.vendorSelected"
                            :items="listVendor"
                            item-text="name"
                            item-value="id"
                            clearable
                            outlined
                            dense
                            @change="filterRegisters()"
                        ></v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            :headers="headersQuickBooks"
                            :items="filteredQuickBooksSearch"
                            :options.sync="options"
                            :loading="loading"
                            :items-per-page="10"
                            no-data-text="No Record Found"
                        >
                            <template v-slot:item.statusDescription="{ item }">
                                <v-chip
                                    :color="getStatusColor(item.status)"
                                    outlined
                                    dark
                                >
                                    {{ item.statusDescription }}
                                </v-chip>
                            </template>
                            
                            <template v-slot:item.action="{item}">
                                <ActionList 
                                    :id="item.id" 
                                    :showButtons="{
                                        view: true,
                                        tryAgain: item.status === 3 ? true : false,
                                        productArrived: item.status === 4 ? true : false,
                                    }"
                                    @confirmTryAgain="confirmTryAgain"
                                    @confirmView="showQuickbooksHistory"
                                    @confirmProductArrived="showProductArrived(item)"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                
            </v-tab-item>

        </v-tabs-items>

		<v-dialog
			v-model="showQBOptions"
			transition="dialog-top-transition"
			persistent
			width="900"
			:fullscreen="$vuetify.breakpoint.mobile"
		>
			<v-card>
				<v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
					QuickBooks - New Purchase Order
				</v-card-title>

				<v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="4"
                            md="4"
                            sm="12"
                        >   
                            <label>Vendor</label>
                            <v-combobox
                                v-model="vendorSelected"
                                :items="listVendor" 
                                item-text="name"
                                item-value="id"
                                clearable
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="4"
                            md="4"
                            sm="12"
                        >   
                            <label>Class</label>
                            <v-combobox
                                v-model="classSelected"
                                :items="listClass" 
                                item-text="description"
                                item-value="id"
                                clearable
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="4"
                            md="4"
                            sm="12"
                        >   
                            <label>Template</label>
                            <v-combobox
                                v-model="templateSelected"
                                :items="listTemplate" 
                                item-text="description"
                                item-value="id"
                                clearable
                                outlined
                                dense
                            ></v-combobox>
                        </v-col>
                    </v-row>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 buttonCancelDialog v-btn-large"
                            style=""
                            outlined
                            @click="showQBOptions = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2 v-btn-large"
                            outlined
                            @click="confirmCreateQuickBookOrders"
                        >
                            Create
                        </v-btn>
                    </div>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="showLog"
			transition="dialog-top-transition"
			persistent
			width="90%"
			:fullscreen="$vuetify.breakpoint.mobile"
		>
			<v-card>
				<v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
					History
				</v-card-title>

				<v-card-text style="margin-top: 20px; text-align: center;">
					<v-data-table
                        :headers="headerLog"
                        :items="listLog"
                        class="elevation-1"
                        :items-per-page="10"
                        no-data-text="No Record Found"
                    >
                        <template v-slot:item.action="{item}">
                            <ActionList 
                                :id="item.id" 
                                :showButtons="{                                    
                                    viewPhotos: item.description.toString().includes('Arrived'),
                                }"
                                @viewPhotos="viewPhotos(item.idPurchaseOrder)"
                            />
                        </template>
                    </v-data-table>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<div style="width: 100%; text-align: center;">

						<v-btn
							class="mx-2"
							outlined
							@click="showLog = false"
						>
							OK
						</v-btn>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>

        <v-dialog
            v-model="showDialogProductArrived"
            transition="dialog-top-transition"
            persistent
            width="1000"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Photos of Products
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-form
                        ref="formProductArrived"
                        v-model="validFormProductArrived"
                        lazy-validation
                    >
                        <v-row>
                            <v-col
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <canvas id="canvas" hidden></canvas>
                                <label>Please upload photos of the products</label>
                                <v-file-input
                                    v-model="productArrivedFilesPhotos" 
                                    accept="image/*"
                                    small-chips
                                    multiple
                                    outlined
                                    placeholder="Click here to add"
                                    prepend-inner-icon="mdi-paperclip"
                                    prepend-icon=""
                                    @change="resizePreviewImage(productArrivedFilesPhotos, productArrivedPhotos)"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                v-for="(itemPhoto, index) in productArrivedPhotos.filter(pht => pht.deleted == false)"
                                :key="index"
                                cols="12"
                                lg="2"
                                md="4"
                                sm="12"
                            >
                                <v-card max-width="200">
                                    <v-img
                                        :src="itemPhoto.src"
                                        :lazy-src="itemPhoto.src"
                                        aspect-ratio="1"
                                        max-height="200"
                                        max-width="200"
                                    >
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                    <span class="imageFileName">{{ itemPhoto.fileName }}</span>
                                    <v-icon class="deletePhotoIcon" small right color="var(--color__red)" @click="confirmPhotoDelete(productArrivedPhotos, itemPhoto)">mdi mdi-delete</v-icon>
                                </v-card>
                            </v-col>
                        </v-row>

                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 buttonCancelDialog v-btn-large"
                            style=""
                            outlined
                            @click="showDialogProductArrived = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2 v-btn-large"
                            outlined
                            @click="saveProductArrived()"
                        >
                            Save
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

        <v-dialog
            v-model="showDialogProductArrivedPictures"
            transition="dialog-top-transition"
            persistent
            width="900"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
        
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Pictures
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col
                            v-for="(itemPhoto, index) in productArrivedPhotos.filter(pht => pht.deleted == false)"
                            :key="index"
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <v-card 
                                max-width="400"
                                style="cursor: pointer;"
                                @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.type, itemPhoto.fileName)"
                            >
                                <v-img
                                    :src="itemPhoto.src"
                                    :lazy-src="itemPhoto.src"
                                    aspect-ratio="1"
                                    max-height="400"
                                    max-width="400"
                                >
                                    <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                        ></v-progress-circular>
                                    </v-row>
                                    </template>
                                </v-img>
                                <span class="imageFileName">{{ itemPhoto.fileName }}</span>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss"
							outlined
							@click="showDialogProductArrivedPictures = false;"
						>
							Dismiss
						</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import { 
        TYPE_DOCUMENT, 
        TYPE_ATTACHMENT,
        URL_ATTACHMENT
    } from "@/utilities/Enums";

    export default ({

        components: {
            ActionList,
            ActionDialog
        },

        mixins: [Helpers],

        data: () => ({

            loading: false,

            tab: null,

            filter: {
                fastSearch: '',
                customerSelected: null,
                productSelected: null,
                onlySpecialOrder: false,
                phaseSelected: null,
                statusSelected: null,
                vendorSelected: null,
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            ordersSelected: null,
            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Project", value: "projectDescription", sortable: true },
                { text: "Type of Work", value: "kindWorkDescription", sortable: true },
                { text: "Product", value: "productName", sortable: true },
                { text: "Qty", value: "qty", sortable: true },
                { text: "Phase", value: "projectPhaseDescription", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            headersQuickBooks: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Vendor", value: "vendorName", sortable: true },
                { text: "Class", value: "classDescription", sortable: true },
                { text: "Template", value: "templateDescription", sortable: true },
                { text: "Qty Total", value: "qtyTotal", sortable: true },
                { text: "QB Ref Number", value: "refNumber", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listOrders: [],
            listQBPurchaseOrders: [],
            listCustomer: [],
            listProduct: [],
            
            listProjectPhases: [],
            listStatus: [],
            
            listLog: [],
            showLog: false,
            headerLog: [
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Description", value: "description", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            showQBOptions: false,
            vendorSelected: null,
            classSelected: null,
            templateSelected: null,
            listVendor: [],
            listClass: [],
            listTemplate: [],

            itemQuickBooks: null,
            validFormProductArrived: false,
            showDialogProductArrived: false,
            note: "",

            productArrivedFilesPhotos: [],
            productArrivedPhotos: [],

            showDialogProductArrivedPictures: false,

            URL_ATTACHMENT
        }),

        props: {
            idServiceProject: {
                default: 0
            }
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            filteredSearch: function() {
                return this.listOrders.filter((orderFilter) => {
                    const query = (this.filter.fastSearch || '').toLowerCase();
                    const fastSearchFields = [
                        orderFilter.dateRegisterFormatted,
                        orderFilter.userNameRegister,
                        orderFilter.customerName,
                        orderFilter.projectDescription,
                        orderFilter.productName,
                        orderFilter.projectPhaseDescription,
                        orderFilter.statusDescription,
                        orderFilter.id
                    ];

                    if (this.filter.customerSelected != null && this.filter.customerSelected != undefined) {
                        const selectedCustomer = (this.filter.customerSelected.fullName || this.filter.customerSelected.name || '').toLowerCase();
                        const currentCustomer = (orderFilter.customerName || '').toLowerCase();

                        if (!currentCustomer.includes(selectedCustomer)) {
                            return false;
                        }
                    }

                    if (this.filter.productSelected != null && this.filter.productSelected != undefined) {
                        const selectedProduct = (this.filter.productSelected.description || '').toLowerCase();
                        const currentProduct = (orderFilter.productName || '').toLowerCase();

                        if (!currentProduct.includes(selectedProduct) && orderFilter.idProduct !== this.filter.productSelected.id) {
                            return false;
                        }
                    }

                    if (this.filter.onlySpecialOrder === true) {
                        const currentSpecialOrder = Number(orderFilter.customOrder ?? 0);

                        if (currentSpecialOrder !== 1) {
                            return false;
                        }
                    }

                    if (this.filter.statusSelected != null && this.filter.statusSelected != undefined && orderFilter.status !== this.filter.statusSelected) {
                        return false;
                    }

                    if (this.filter.phaseSelected != null && this.filter.phaseSelected != undefined && orderFilter.projectPhase !== this.filter.phaseSelected) {
                        return false;
                    }

                    if (query) {
                        const matches = fastSearchFields.some(field => {
                            if (field == null || field == undefined) {
                                return false;
                            }

                            return field.toString().toLowerCase().includes(query);
                        });

                        if (!matches) {
                            return false;
                        }
                    }

                    return true;
                });
            },

            filteredQuickBooksSearch: function() {
                return this.listQBPurchaseOrders.filter((qbPurchaseOrderFilter) => {
                    const query = (this.filter.fastSearch || '').toLowerCase();
                    const fastSearchFields = [
                        qbPurchaseOrderFilter.dateRegisterFormatted,
                        qbPurchaseOrderFilter.userNameRegister,
                        qbPurchaseOrderFilter.vendorName,
                        qbPurchaseOrderFilter.classDescription,
                        qbPurchaseOrderFilter.templateDescription,
                        qbPurchaseOrderFilter.statusDescription,
                        qbPurchaseOrderFilter.id
                    ];

                    if (this.filter.statusSelected != null && this.filter.statusSelected != undefined && qbPurchaseOrderFilter.status !== this.filter.statusSelected) {
                        return false;
                    }

                    if (this.filter.vendorSelected != null && this.filter.vendorSelected != undefined) {
                        const selectedVendor = (this.filter.vendorSelected.name || '').toLowerCase();
                        const currentVendor = (qbPurchaseOrderFilter.vendorName || '').toLowerCase();

                        if (!currentVendor.includes(selectedVendor)) {
                            return false;
                        }
                    }

                    if (query) {
                        const matches = fastSearchFields.some(field => {
                            if (field == null || field == undefined) {
                                return false;
                            }

                            return field.toString().toLowerCase().includes(query);
                        });

                        if (!matches) {
                            return false;
                        }
                    }

                    return true;
                });
            },

            disabledCreate: function() {
                return this.ordersSelected == null || 
                       this.ordersSelected == undefined || 
                       this.ordersSelected.length <= 0
            },

            canApproveRequestWareHouse() {
                return this.userLoggedGetters.profile.canApproveRequestWareHouse == 1;
            },
        },

        methods: {

            filterRegisters() {
                return true;
            },

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 1:
                        color = 'var(--color__status_pending)';
                        break;

                    case 2:
                        color = 'var(--color__main)';
                        break;

                    case 3:
                    case 99:
                        color = 'var(--color__red)';
                        break;

                    default:
                        color = 'var(--color__main)';
                        break;
                }

                return color
            },

            async getLists() {
                
                this.listProjectPhases = await this.$store.dispatch("serviceModule/ListStatus");
                const listStatus = await this.$store.dispatch("warehouseModule/ListOrderStatus");
                this.listStatus = listStatus.filter(status => status.id !== 0);
                this.listCustomer = await this.$store.dispatch("customerModule/List");
                this.listProduct = await this.$store.dispatch("productModule/List");
                this.listVendor = await this.$store.dispatch("qbVendorModule/List");
                this.listClass = await this.$store.dispatch("qbClassModule/List");
                this.listTemplate = await this.$store.dispatch("qbTemplateModule/List");
            },
            
            async getOrders() {

                const orderFilterRequest = {
                    idOrder: 0,
                    idServiceProject: this.idServiceProject,
                    idProduct: 0,
                    onlySpecialOrder: this.filter.onlySpecialOrder,
                }

                if (this.idServiceProject && this.idServiceProject != 0 && this.idServiceProject != null) {
                    await this.$store.dispatch("warehouseModule/CheckWarehouseOrders", orderFilterRequest);
                }

                this.listOrders = await this.$store.dispatch("warehouseModule/OrdersList", orderFilterRequest);
            },
            
            async getQuickBooksPurchaseOrders() {

                this.listQBPurchaseOrders = await this.$store.dispatch("qbPurcharseOrderModule/List");
            },

            confirmCancel(id) {

                this.statusId = 99;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will CANCEL this Order, confirm your decision?',
                    methodConfirm: this.cancel,
                    params: id
                };
            },

            async cancel(id) {

                const statusId = this.statusId;

                this.showLoading();

                const result = await this.$store.dispatch("warehouseModule/OrdersUpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getOrders();

                this.hideLoading();
            },

            confirmActive(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'You will ACTIVATE this Order, confirm your decision?',
                    methodConfirm: this.active,
                    params: id
                };

            },

            async active(id) {

                this.showLoading();
                const statusId = this.statusId;

                const result = await this.$store.dispatch("warehouseModule/OrdersUpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getOrders();

                this.hideLoading();
            },

            async showHistory(id) {
                this.showLoading();

                this.listLog = await this.$store.dispatch("warehouseModule/OrdersListHistory", id);
                this.showLog = true;

                this.hideLoading();
            },

            async showQuickbooksHistory(id) {
                this.showLoading();

                this.listLog = await this.$store.dispatch("qbPurcharseOrderModule/ListHistory", id);
                this.showLog = true;

                this.hideLoading();
            },

            async confirmSendToApproveQBOrder() {

                if (this.ordersSelected == null || this.ordersSelected == undefined || this.ordersSelected.length <= 0) {
                    this.showToast("error", "Error!", "Please select at least one order to create the purchase order in QuickBooks.");
                    return;
                }
                else {
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: 'You will SEND for Approval this Orders, confirm your decision?',
                        methodConfirm: this.sendToApproveQBOrder,
                        params: 0
                    };
                }
            },

            async sendToApproveQBOrder() {

                if (this.ordersSelected == null || this.ordersSelected == undefined || this.ordersSelected.length <= 0) {
                    this.showToast("error", "Error!", "Please select at least one order to create the purchase order in QuickBooks.");
                    return;
                }
                else {
                    this.showLoading();
                    
                    const listOrdersID = this.ordersSelected.map(order => order.id).join(';');

                    listOrdersID.split(';').forEach(async id => {
                        const statusId = 2;

                        const result = await this.$store.dispatch("warehouseModule/OrdersUpdateStatus", { id, statusId });

                        if (result.success) {
                            this.showToast("success", "Success!", result.message);
                        }
                        else {
                            this.showToast("error", "Error!", result.message);
                        }
                    });
                    
                    await this.getOrders();

                    this.hideLoading();
                    // this.showQBOptions = true;
                }
            },

            async confirmCreateQuickBookOrders() {

                if (this.vendorSelected == null || this.vendorSelected == undefined) {
                    this.showToast("error", "Error!", "Please select a vendor.");
                    return;
                }
                else if (this.classSelected == null || this.classSelected == undefined) {
                    this.showToast("error", "Error!", "Please select a class.");
                    return;
                }
                else if (this.templateSelected == null || this.templateSelected == undefined) {
                    this.showToast("error", "Error!", "Please select a template.");
                    return;
                }
                else {
                    this.dialog = {
                        show: true,
                        headerText: 'Confirmation',
                        bodyText: 'You will create a new order to quick books, confirm your decision?',
                        methodConfirm: this.createQuickBookOrders,
                        params: 0
                    };
                }
            },

            async createQuickBookOrders() {                      
                const listOrdersID = this.ordersSelected.map(order => order.id).join(';');

                const qbPurchaseRequest = {
                    listOrdersID,
                    idVendor: this.vendorSelected.id,
                    idClass: this.classSelected.id,
                    idTemplate: this.templateSelected.id
                }

                this.showLoading();

                const result = await this.$store.dispatch("qbPurcharseOrderModule/CreateByListOrders", qbPurchaseRequest);

                if (result.success === true) {
                    this.showQBOptions = false;
                    this.showToast("success", "Success!", "A purchase order was created and is pending for integration with QuickBooks.");
                    this.getOrders();
                }
                else {
                    this.showToast("error", "Warning!", result.message);
                }

                this.hideLoading();

            },

            async confirmTryAgain(id) {

                this.statusId = 1;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'Will you try to integrate this purchase order again, confirm your decision?',
                    methodConfirm: this.tryAgain,
                    params: id
                };

            },

            async tryAgain(id) {

                this.showLoading();
                const statusId = this.statusId;

                const result = await this.$store.dispatch("qbPurcharseOrderModule/UpdateStatus", { id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getQuickBooksPurchaseOrders();

                this.hideLoading();
            },
            
            async confirmPhotoDelete(listPhotos, itemPhotoToDelete) {

                this.listPhotosDelete = listPhotos;
                this.itemPhotoToDelete = itemPhotoToDelete;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will DELETE this image [${itemPhotoToDelete.fileName}], confirm your decision?`,
                    methodConfirm: this.deletePhoto,
                    params: 0
                };
            },

            async deletePhoto() {

                this.itemPhotoToDelete.deleted = true;
            },

            async showProductArrived(item) {
                this.itemQuickBooks = item;
                this.note = "";
                this.productArrivedFilesPhotos = [];
                this.productArrivedPhotos = [];
                this.showDialogProductArrived = true;
            },

            async saveProductArrived() {

                await this.$refs.formProductArrived.validate();

                if (this.validFormProductArrived === false) {
                    this.showToast("error", "Warning!", "There are inconsistencies in the notes form. Please review!");
                    return false;
                }
                else {
                    await this.confirmProductArrived();
                }
            },

            async uploadFiles(id, idKey, file, typeDocument, deleted = false) {

                let attachmentRequest = {
                    id: id,
                    idKey: idKey,
                    file: file ? file : new Blob(),
                    fileName: file ? file.name : "",
                    fileType: file ? file.type : "",
                    fileSize: file ? file.size : 0,
                    deleted: deleted ? deleted : false,
                    typeAttachment: TYPE_ATTACHMENT.WAREHOUSE.value,
                    typeDocument: typeDocument,
                }

                if (attachmentRequest.fileName != null && attachmentRequest.fileName != undefined) {
                    let attachmentFileRequest = new FormData();

                    attachmentFileRequest.append("attachmentRequest", JSON.stringify(attachmentRequest));
                    attachmentFileRequest.append("attachmentFile", attachmentRequest.file, attachmentRequest.fileName);

                    const result = await this.$store.dispatch("attachmentModule/CreateUpdate", { 
                        attachmentFileRequest, 
                        id: 0
                    });

                    return result;
                }
                else {
                    return {
                        success: true
                    };
                }
            },

            async savePhotos() {

                let allResult = []

                this.productArrivedPhotos.forEach(async itemPhoto => {

                    let result = await this.uploadFiles(itemPhoto.id, this.itemQuickBooks.id, itemPhoto.file, TYPE_DOCUMENT.PRODUCT_ARRIVED.value, itemPhoto.deleted);

                    if (result.success == false) {
                        allResult.push({
                            typeDocument: TYPE_DOCUMENT.PRODUCT_ARRIVED.description,
                            message: result.message
                        })
                    }
                })

                if (allResult.length > 0) {
                    let message = ""

                    await allResult.forEach(itemResult => {
                        message += `Error to upload pictures: [${itemResult.message}] \n`;
                    })

                    this.showToast("error", "Warning!", message);

                    return false;
                }
                else {
                    return true;
                }
            },

            async confirmProductArrived() {

                this.statusId = 5;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: 'Will you confirm that the product has arrived?',
                    methodConfirm: this.productArrived,
                    params: null
                };

            },

            async productArrived() {

                this.showLoading();

                if (await this.savePhotos() == false) {
                    this.hideLoading();
                    return;
                }

                const statusId = this.statusId;

                const result = await this.$store.dispatch("qbPurcharseOrderModule/UpdateStatus", { id: this.itemQuickBooks.id, statusId });

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showDialogProductArrived = false;
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getQuickBooksPurchaseOrders();

                this.hideLoading();
            },

            async viewPhotos(idPurchaseOrder) {
                this.showLoading();

                const listAttachments = await this.$store.dispatch("attachmentModule/GetAllByDocument", { 
                    typeAttachment: TYPE_ATTACHMENT.WAREHOUSE.value, 
                    typeDocument: TYPE_DOCUMENT.PRODUCT_ARRIVED.value, 
                    idKey: idPurchaseOrder
                });

                this.productArrivedPhotos = [];

                if (listAttachments != null && listAttachments != undefined) {
                    listAttachments.forEach(itemPhoto => {
                        this.productArrivedPhotos.push({
                            id: itemPhoto.id,
                            file: new File([], itemPhoto.fileName),
                            type: itemPhoto.fileType,
                            fileName: itemPhoto.fileNameShort,
                            fileNameComplete: itemPhoto.fileName,
                            deleted: false,
                            src: `data:image/jpg;base64,${itemPhoto.file}`
                        })
                    })
                }

                this.hideLoading();

                this.showDialogProductArrivedPictures = true;
            },
        },

        async created() {
            this.showLoading();
            await this.getLists();
            await this.getOrders();
            this.hideLoading();
        }
    })
</script>
